/* eslint-disable react/require-default-props */
// Temporary Component to avoid SSR error for fusion accordion
import React from 'react';
import { ProductOverviewAccordionTitle } from '@thd-olt-component-react/product-overview';
import proptypes from 'prop-types';

const { bool } = proptypes;

export const BundleProductOverviewAccordionTitle = ({ disableHeight = false }) => {
  return <ProductOverviewAccordionTitle disableHeight={disableHeight} />;
};

BundleProductOverviewAccordionTitle.propTypes = {
  disableHeight: bool
};

BundleProductOverviewAccordionTitle.displayName = 'BundleProductOverviewAccordionTitle';
